const hotel = {
  availableMealPlans: "Các gói bữa ăn hiện có", // translated 
  availableRoomsTypes: "Các loại phòng có sẵn", // translated 
  cancellationPolicy: "Chính sách hủy bỏ", // translated 
  cancellationRules: "Quy tắc hủy bỏ", // translated 
  freeCancellationAvailable: "Có thể hủy đặt phòng miễn phí.", // translated 
  nonRefundable: "Không hoàn tiền", // translated 
  priceFor: "Giá cho", // translated 
  nights: "đêm", // translated 
  totalPrice: "Tổng giá", // translated 
  seeAvailability: "Xem tình trạng còn hàng", // translated 
  myProfile: "Hồ sơ của tôi", // translated 
  travelTrust: "Quỹ tín thác du lịch", // translated 
  signIn: "Đăng nhập", // translated 
  searchNow: "Tìm kiếm ngay", // translated 
  policy: "Chính sách", // translated 
  cxlRules: "Quy tắc CXL", // translated 
  room: "phòng", // translated 
  cxlPolicy: "Chính sách CXL", // translated 
  beddingType: "Loại chăn ga gối", // translated 
  hotelName: "Tên khách sạn", // translated 
  reservationDate: "Ngày đặt chỗ", // translated 
  maxPax: "Số lượng khách tối đa", // translated 
};


export default hotel;
